import { render, staticRenderFns } from "./modalBloqueioExame.vue?vue&type=template&id=877f8e20&"
import script from "./modalBloqueioExame.vue?vue&type=script&lang=js&"
export * from "./modalBloqueioExame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports